import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { buttonVariants } from '@/components/ui/Button';
import { useSubscriptionQuery } from './api';

/*
 * CancelScheduledBanner (Sessio 19b).
 *
 * Renderoidaan AppLayout:n yli (TrialBanner / BudgetWarningBanner -pattern) kun
 * tilaus on peruutettu kauden lopussa: subscription_cancel_at != null ja status
 * active/trialing. Kertoo selkeasti milloin tilaus paattyy ja etta sen jalkeen
 * siirrytaan read-only-tilaan (Petrin paatos 19b: peruutus-naytto, ei aitoa
 * Team->Solo-vaihtoa).
 */

function formatDate(value: string | null, locale: string): string | null {
  if (!value) return null;
  const normalized = value.includes('T') ? value : value.replace(' ', 'T') + 'Z';
  const d = new Date(normalized);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleDateString(locale, { year: 'numeric', month: 'long', day: 'numeric' });
}

export function CancelScheduledBanner() {
  const { t, i18n } = useTranslation();
  const { data } = useSubscriptionQuery();

  if (!data) return null;
  const status = data.subscription_status;
  const cancelAt = formatDate(data.subscription_cancel_at, i18n.language);
  if (!cancelAt || (status !== 'active' && status !== 'trialing')) return null;

  return (
    <div
      role="region"
      aria-label={t('billing.cancel_scheduled.regionLabel')}
      className="border-b border-oranssi bg-oranssi/10 px-6 py-3 text-sm text-teksti lg:px-10"
    >
      <div className="mx-auto flex max-w-[var(--content-max)] flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <strong className="font-semibold">
          {t('billing.cancel_scheduled.body', { date: cancelAt })}
        </strong>
        <Link to="/billing" className={buttonVariants({ variant: 'secondary', size: 'sm' })}>
          {t('billing.cancel_scheduled.cta')}
        </Link>
      </div>
    </div>
  );
}
